module.exports = require('./dist/ReactCrop');


//////////////////
// WEBPACK FOOTER
// ./~/react-image-crop/index.js
// module id = 1760
// module chunks = 1